export default __webpack_public_path__ + "static/media/payment-popup-web.f0447660.png";